import BaseService from "./base.service";

/**
 * AUCR-753 — service para o fluxo público de upgrade de doação recorrente.
 *
 * Estende BaseService para herdar:
 *   - desempacotamento automático do envelope { data: {...} } usado por todo o back-end
 *   - tratamento padrão de 401 / erro / loader global
 *
 * Endpoints consumidos:
 *   GET  /UpgradeDonation/GetByCheckoutCode?checkoutCode={guid}&u={base64url}
 *   POST /UpgradeDonation/Confirm  { checkoutCode, newValue, upgradeConfig }
 *
 * `u` (contrato CONTRATO_UPGRADE_URL.md) é repassado cru ao back, que decodifica, valida e
 * recalcula as opções sobre o valor real do carrinho — o front não decodifica nem confia no `u`.
 *
 * `showMessage = false` em ambos: a view exibe seus próprios estados (loadError / submitError),
 * sem swal global. `showLoader = false`: o componente tem indicador local.
 */
export default class UpgradeDonationService extends BaseService {
    constructor() {
        super("UpgradeDonation");
    }

    /**
     * Busca os dados da tela (doador, valor atual, opções, branding) a partir do hash.
     * @param {string} checkoutCode Guid do Cart enviado no link de e-mail.
     * @param {string|null} upgradeConfig Parâmetro `u` do link (opcional).
     */
    getByCheckoutCode(checkoutCode, upgradeConfig = null) {
        const params = { checkoutCode };
        if (upgradeConfig) params.u = upgradeConfig;
        return this.getRequest("GetByCheckoutCode", params, false, false);
    }

    /**
     * Confirma o upgrade com o novo valor escolhido pelo doador (opção ou valor livre).
     * O backend revalida o valor (maior que o atual, +R$ 5 mínimo, múltiplo de R$ 5, até 10x)
     * e usa o `upgradeConfig` só para identificar qual opção foi escolhida (rastreio).
     */
    confirm(checkoutCode, newValue, upgradeConfig = null) {
        return this.postRequest(
            "Confirm",
            { checkoutCode, newValue, upgradeConfig },
            false,
            false
        );
    }
}
